import txBase, {TO_SAVE_BASE, KEY, initState as baseState} from '../../../vuex/tx-base';
import {registerModule} from '../../../vuex/helpers/vuex-pathify-register-module';
import {sync, make} from 'vuex-pathify'

import deepmerge from "deepmerge";
import templateResetMutation from "../../../vuex/helpers/template-reset-mutation";
import defaultState from "../../../vuex/helpers/default-state";
import {initTemplateSettings} from "../../../vuex/helpers/default-state-value";

const STORE_NAMESPACE = 'student-poster';


let mapData = window[KEY];

let productDefault = {
    mapSize: "50x70cm",
    // studentName: 'Tomas',
    studentName: 'Astrid',
    studentCode: 'sa2d',
    gratisText: 'Grattis!',
    gratisSText: 'Grattis till studenten',
    yearText: '2023',
    studentEdit: 'Studenten',
    mainStyle: 'style-1',
    styles: null,
    cropImg: '',
}


export const initState = (mapData) => {
    let config = initTemplateSettings();

    if (Array.isArray(config.styles)) {
        productDefault.mainStyle = config.styles[0]
    }
    if (typeof config.styles === 'string') {
        productDefault.mainStyle = config.styles
    }

    return defaultState(mapData, productDefault)
}

let vuexModule = {};
vuexModule.state = initState(mapData);

vuexModule.mutations = {
    ...make.mutations(vuexModule.state),
    reset: templateResetMutation(initState, STORE_NAMESPACE)
}

const EXCLUDE_FROM_SAVE = ['styles'];

let SAVE_PARAMS = [
    ...TO_SAVE_BASE,
    ...Object.keys(vuexModule.state).filter(item => !!EXCLUDE_FROM_SAVE.findIndex(exclude => item === exclude))
]

let extendedModule = deepmerge(txBase, vuexModule);

function members() {
    const {state} = extendedModule;
    let computed = {};
    for (let [key, value] of Object.entries(state)) {
        computed[key] = sync(`${STORE_NAMESPACE}/${key}`)
    }

    computed.toSaveParams = function () {
        let toSaveParams = {};
        for (let key of SAVE_PARAMS) {
            toSaveParams[key] = this[key]
        }
        return toSaveParams
    };

    return {
        computed,
    }
}


export default StudentPosterModule => {
    return registerModule(STORE_NAMESPACE, extendedModule, members);
}
